<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useFunctionGetter, useStore } from 'dashboard/composables/store';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const route = useRoute();
const store = useStore();
const inbox = useFunctionGetter('inboxes/getInboxById', route.params.id);
const loadState = ref('loading');

const loadInboxes = async () => {
  loadState.value = 'loading';
  try {
    const result = await store.dispatch('inboxes/get');
    if (result === null) {
      loadState.value = 'error';
      return;
    }
    loadState.value = inbox.value.id ? 'ready' : 'not_found';
  } catch {
    loadState.value = 'error';
  }
};

onMounted(loadInboxes);
</script>

<template>
  <WootReports
    v-if="inbox.id"
    :key="inbox.id"
    type="inbox"
    getter-key="inboxes/getInboxes"
    action-key="inboxes/get"
    :selected-item="inbox"
    :download-button-label="$t('INBOX_REPORTS.DOWNLOAD_INBOX_REPORTS')"
    :report-title="$t('INBOX_REPORTS.HEADER')"
    has-back-button
  />
  <div v-else-if="loadState === 'loading'" class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
  <div v-else class="flex w-full flex-col items-center gap-3 py-20 text-center">
    <p class="m-0 text-n-slate-11">
      {{
        $t(
          loadState === 'error'
            ? 'REPORT.DATA_FETCHING_FAILED'
            : 'REPORT.FILTER_ACTIONS.EMPTY_LIST'
        )
      }}
    </p>
    <V4Button
      v-if="loadState === 'error'"
      :label="$t('REPORT.FILTER_PANEL.RETRY')"
      size="sm"
      @click="loadInboxes"
    />
  </div>
</template>
